import { BaseResourcesApi } from './base-resource-api';

const getBaseUrl = (): string => {
  return `/admin`;
};

export const AdminResourcesApi = new BaseResourcesApi(getBaseUrl);
